export const toPersianQuality = {
  class_1: {
    degree: 1,
    bgColor: '#FFF2E4',
    textColor: '#F29E4C',
  },
  class_2: {
    degree: 2,
    bgColor: '#F1F8FF',
    textColor: '#0053AD',
  },
  class_3: {
    degree: 3,
    bgColor: '#FFF1EF',
    textColor: '#F2634C',
  },
  class_4: {
    degree: 4,
    bgColor: '#EFFBF7',
    textColor: '#2B999C',
  },
};
